// Port of getBatches (chart.coffee:260-322).
// No trait   — 3 fixed variants (Purchased / Picked up only / No action).
// With trait — 3*N variants (one block of 3 per traitValue).

export const getBatches = ({ answerVariants, trait, traitValues }) => {
  return (answerVariants || []).map(av => {
    const batch = { position: av.position, text: av.text, fixed: false }

    if (trait) {
      batch.answerVariants = []
      ;(traitValues || []).forEach((traitValue, idx) => {
        const base = idx * 3
        batch.answerVariants.push(
          {
            position: base + 1,
            text: `Purchased, ${traitValue.name}`,
            fixed: false,
            positive: true,
            score: base + 1
          },
          {
            position: base + 2,
            text: `Picked up only, ${traitValue.name}`,
            fixed: false,
            positive: true,
            score: base + 2
          },
          {
            position: base + 3,
            text: `No action, ${traitValue.name}`,
            fixed: false,
            positive: true,
            score: base + 3
          }
        )
      })
    } else {
      // Inline literals (NOT a shared module-level constant) — each batch gets its own
      // array & objects, matching coffee chart.coffee:296-318 behavior and avoiding
      // accidental cross-batch mutation by Highcharts.
      batch.answerVariants = [
        { position: 1, text: 'Purchased', fixed: false, positive: true, score: 1 },
        { position: 2, text: 'Picked up only', fixed: false, positive: true, score: 2 },
        { position: 3, text: 'No action', fixed: false, positive: true, score: 3 }
      ]
    }

    return batch
  })
}
